import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';

import packagesReducer from './packages/reducer';
import referralsReducer from './referrals/reducer';
import expensesReducer from './expenses/reducer';
import customernotificationsReducer from './customernotifications/reducer';
//end-of-imports

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  packagesReducer,
  referralsReducer,
  expensesReducer,
  customernotificationsReducer,
  //end-of-reducers
});

export default reducers;